import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyPayment } from '../../services/subscriptionApis';
import { SuccessAlert } from '../../components/common/ErrorAlert/SuccessAlert';
import usePlanExpiredPopupStore from '../../store/Useplanexpiredpopupstore';
import { clearPlanSelection } from '../../utils/cookies';

export default function StripeSuccess() {
    const [params]   = useSearchParams();
    const navigate   = useNavigate();
    const [msg, setMsg] = useState('Verifying your payment…');

    useEffect(() => {
        const sessionId = params.get('session_id');
        if (!sessionId) { navigate('/home'); return; }

        verifyPayment({ session_id: sessionId })
            .then(res => {
                clearPlanSelection();
                usePlanExpiredPopupStore.getState().clearPlanExpiredPopup();

                const type = res?.subscription_type;
                if (type === 'new') {
                    SuccessAlert('🎉 Welcome! Your subscription is now active.');
                } else if (type === 'renewal') {
                    SuccessAlert('✅ Plan renewed successfully! Your access continues.');
                } else if (type === 'upgrade') {
                    SuccessAlert('🚀 Plan upgraded successfully!');
                } else if (type === 'addon') {
                    SuccessAlert('✅ Plan customized successfully!');
                } else {
                    // SuccessAlert('Payment successful!');
                }

                navigate('/dashboard');
            })
            .catch(() => {
                setMsg('Verification failed. Please contact support.');
                setTimeout(() => navigate('/dashboard'), 3000);
            });
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center',
                      alignItems: 'center', minHeight: '60vh' }}>
            <p>{msg}</p>
        </div>
    );
}